import Vue from 'vue';
import Endpoints from '@/share/Endpoints';

export const getPublicationSectionsByOrg = async ({ commit }) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: Endpoints.publicationSectionsOrganization,
    });
    commit('setSections', data.sections || []);
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const getPublicationSectionsForMember = async ({ commit }) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: Endpoints.publicationSectionsMember,
    });
    commit('setSections', data.sections || []);
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const addPublicationSection = async ({ commit }, payload) => {
  try {
    const { data } = await Vue.axios({
      method: 'POST',
      url: Endpoints.publicationSectionsCreate,
      data: { section: payload },
    });
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const updatePublicationSection = async ({ commit }, { id, payload }) => {
  try {
    const { data } = await Vue.axios({
      method: 'PUT',
      url: Endpoints.publicationSectionsUpdate.replace(':sectionId', id),
      data: { section: payload },
    });
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};

export const deletePublicationSection = async ({ commit }, id) => {
  try {
    const { data } = await Vue.axios({
      method: 'DELETE',
      url: Endpoints.publicationSectionsDelete.replace(':sectionId', id),
    });
    return { status: true, data };
  } catch (error) {
    return { status: false, message: error };
  }
};
